import { createSelector } from "@ngrx/store";
import { AppStateInterface } from "../../appState.interface";

export const selectFeature = (state: AppStateInterface) => state.deviceManufacturers;

export const isLoadingSelector = createSelector(
    selectFeature, 
    (state) => state.isLoading
);

export const deviceManufacturerSelector = createSelector(
    selectFeature, 
    (state) => state.deviceManufacturers
);

export const deviceManufacturersTotalSelector = createSelector(
    selectFeature, 
    (state) => state.total
);

export const errorSelector = createSelector(
    selectFeature, 
    (state) => state.error
);